<div class="app" style="margin-bottom: 120px;">

  <!-- Main content -->
  <main class="content">
    <h1 class="title"> {{ "What can I help with?" | transloco}}</h1>
    <div class="col-12" style="text-align: center;">
      <img class="searchimg" src="/assets/e-commerce/icons/52.webp" alt="" />
    </div>

    <!-- Desktop input card (hidden on mobile) -->
    <section class="desktop-center" *ngIf="!isMobile">
      <label class="ask"> {{ "Ask anything" | transloco}}</label>
      <div class="composer-inner">

        <input id="desktop-input" type="text" [placeholder]="placeholderText" [(ngModel)]="searchkey"
          (focus)="stopRotation()" (keyup.enter)="testSearchKey()" (blur)="startRotation()" class="form-control" />

        <button class="btn send" title="send" (click)="testSearchKey()">

          <img class="profile-icon" src="/assets/Search_Icons_UIA.png">

        </button>
      </div>
    </section>

    <!-- Spacer grows on mobile focus (best-effort visual only) -->
    <div class="keyboard-spacer"></div>
  </main>

  <!-- Bottom composer (mobile only; hidden on desktop via media query) -->
  <footer class="composer" *ngIf="isMobile">
    <label class="ask"> {{ "Ask anything" | transloco}}</label>
    <div class="composer-inner" id="mobile-bar">

      <input id="desktop-input" type="text" [placeholder]="placeholderText" [(ngModel)]="searchkey"
        (focus)="stopRotation()" (keyup.enter)="testSearchKey()" (keyup.enter)="testSearchKey()" #mobileInput
        (blur)="startRotation()" class="form-control" />

      <button class="btn send" title="send" (click)="testSearchKey()">
        <img class="profile-icon" src="/assets/Search_Icons_UIA.png">
      </button>
    </div>
  </footer>
</div>

<script>
  const mobileInput = document.getElementById('mobile-input');
  if (mobileInput) {
    mobileInput.addEventListener('focus', () => document.body.classList.add('keyboard-open'));
    mobileInput.addEventListener('blur', () => document.body.classList.remove('keyboard-open'));
  }
</script>